import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/odnoklassniki-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M184.2 177.1C184.2 155 202.1 137.1 224 137.1S263.8 155 263.8 177.1C263.8 199.1 245.9 216.9 224 216.9S184.2 199 184.2 177.1zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM142.9 177.1C142.9 221.7 179.3 258 224 258S305.1 221.8 305.1 177.1C305.1 132.3 268.7 96 224 96S142.9 132.2 142.9 177.1zM317.4 267.8C312.8 258.7 300.1 251 283.3 264.2 283.3 264.2 260.6 282.2 224 282.2S164.7 264.2 164.7 264.2C147.9 251 135.2 258.7 130.6 267.8 122.7 283.9 131.7 291.5 152 304.8 169.3 315.9 193.2 320 208.6 321.6L195.7 334.5C177.5 352.5 160.2 370 148 382.2 130.4 399.8 158.7 428 176.4 410.8L224.1 362.9C242.3 381.1 259.8 398.6 271.8 410.8 289.4 428 317.8 400.1 300.4 382.2L252.7 334.5 239.7 321.6C255.2 320 278.8 315.7 295.9 304.8 316.3 291.5 325.2 283.8 317.4 267.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/odnoklassniki-square.js
// module id = r5zx
// module chunks = 144